const APP_URL = process.env.REACT_APP_URL;
const PDF_URL = process.env.REACT_APP_PDF_URL;
const API_URL = process.env.REACT_APP_API_URL;
const SHORTENER_URL = process.env.REACT_APP_SHORTENER_URL;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
const IDENTITY_POOL = process.env.REACT_APP_IDENTITY_POOL;
const PLAID_PUBLIC_KEY = process.env.REACT_APP_PLAID_PUBLIC_KEY;
const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string;
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY as string;
const MEDIA_PREFIX =
  process.env.REACT_APP_MEDIA_PREFIX === 'null' ? '' : process.env.REACT_APP_MEDIA_PREFIX;
const ENV_NAME = process.env.REACT_APP_ENV;
const SENTRY_URL = process.env.REACT_APP_SENTRY_URL;

export {
  APP_URL,
  PDF_URL,
  API_URL,
  SHORTENER_URL,
  CLIENT_ID,
  CLIENT_SECRET,
  IDENTITY_POOL,
  PLAID_PUBLIC_KEY,
  STRIPE_PUBLIC_KEY,
  GOOGLE_MAPS_KEY,
  MEDIA_PREFIX,
  ENV_NAME,
  SENTRY_URL,
};
